<body>
  <div class="dash">
    <app-sidebar></app-sidebar>
    <div class="dash-app">
      <app-header style="margin-bottom: 0%;"></app-header>
      <main class="dash-content" style="padding-top: 0%">
        <div class="bs-example">
          <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let clinic of clinicArray; let index = index">
              <a *ngIf="(clinic?.hospitalId && clinic?.hospitalId._id)" [href]="'#' + index"
                (click)="changeclinic(index, clinicArray[index]?._id)" class="nav-link"
                [ngClass]="{ active: index == curIndex }" data-toggle="tab">
                <h6 style="color: rgb(21, 192, 135);">
                  <img title="Online" *ngIf="clinic?.clinicStatus == 'ONLINE'" class="activeIcon img-fluid"
                    style="height: 20px;width: 20px;" src="../../../../assets/img/green2.gif">
                  {{ clinic?.hospitalId?.name }}
                </h6>
                <h6 style="color: rgb(21, 192, 135);height: 20px;" *ngIf="clinic?.clinicStatus != 'ONLINE'">
                </h6>
              </a>
              <a *ngIf="!(clinic?.hospitalId)" [href]="'#' + index"
                (click)="changeclinic(index, clinicArray[index]?._id)" class="nav-link"
                [ngClass]="{ active: index == curIndex }" data-toggle="tab">
                <h6>
                  <img title="Online" *ngIf="clinic?.clinicStatus == 'ONLINE'" class="activeIcon img-fluid"
                    style="height: 20px;width: 20px;" src="../../../../assets/img/green2.gif">
                  {{ clinic?.clinicName }}
                </h6>
                <h6 style="color: rgb(21, 192, 135);" *ngIf="clinic?.clinicStatus != 'ONLINE'">
                </h6>
              </a>
            </li>
          </ul>
          <div class="tab-content clinic-content">
            <div class="tab-pane fade show active" id="{{ curIndex }}">
              <div class="row">
                <div *ngIf="changeable" class="col-md-4">
                  <img [src]="this.path + (clinicArray[curIndex]?.clinicImages)[0]" class="img-thumbnail"
                    style="height: 200px;width:60%;margin-left: 25px;"
                    *ngIf="(clinicArray[curIndex]?.clinicImages)[0]" />
                  <img src="../../../assets/clinic1.jpg" class="img-thumbnail"
                    style="height: 200px;width:60%;margin-left: 25px;"
                    *ngIf="!(clinicArray[curIndex]?.clinicImages)[0]" />
                </div>
                <div *ngIf="!changeable" class="col-md-4">
                  <img [src]="this.path + (clinicArray[curIndex]?.hospitalId?.hospitalImages)[0].hospitalThumbnail"
                    class="img-thumbnail" style="width: 200px; height: 60%;margin-left: 25px;"
                    *ngIf="(clinicArray[curIndex]?.hospitalId?.hospitalImages)[0]" />
                  <img src="../../../assets/clinic1.jpg" class="img-thumbnail"
                    style="height: 200%;width:60%;margin-left: 25px;"
                    *ngIf="!(clinicArray[curIndex]?.hospitalId?.hospitalImages)[0]" />
                </div>
                <div *ngIf="!changeable" class="col-md-4">
                  <h4 class="mt-2">{{ clinicArray[curIndex]?.hospitalId?.name }}</h4>
                  <div>
                    <p>
                      <i class="fa fa-clock-o"></i>
                      {{ clinicArray[curIndex]?.timming?.startTime }} -
                      <i class="fa fa-clock-o"></i>
                      {{ clinicArray[curIndex]?.timming?.endTime }}
                    </p>
                    <p>
                      <i class="fa fa-map-marker"></i>
                      {{ clinicArray[curIndex]?.hospitalId?.address?.address }}
                      {{ clinicArray[curIndex]?.hospitalId?.address?.city }}
                      {{ clinicArray[curIndex]?.hospitalId?.address?.state }}-
                      {{ clinicArray[curIndex]?.hospitalId?.address?.pincode }}
                    </p>

                    <p>
                      <span>Weekly Available : </span>

                      <span class="badge badge-success" style="margin-right: 5px;"
                        *ngFor="let wd of clinicArray[curIndex]?.weekDays">{{ wd.slice(0, 3) }}</span>
                    </p>
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                      <label *ngIf="clinicArray[curIndex]?.slot == 1" class="btn btn-secondary checkedBefore"
                        [ngClass]="{ checked :clinicArray[curIndex].slot == 1}">
                        <p style="margin-bottom: 0;"> Slot One</p>
                      </label>
                      <label *ngIf="clinicArray[curIndex]?.slot == 2" data-toggle="modal" data-target="#changeSlot"
                        (click)="selectSlot(1)" class="btn btn-secondary checkedBefore">
                        <p style="margin-bottom: 0;"> Slot One</p>
                      </label>
                      <label *ngIf="clinicArray[curIndex]?.slot == 1" data-toggle="modal" data-target="#changeSlot"
                        (click)="selectSlot(2)" class="btn btn-secondary checkedBefore">
                        <p style="margin-bottom: 0;"> Slot Two</p>
                      </label>
                      <label *ngIf="clinicArray[curIndex]?.slot == 2" class="btn btn-secondary checkedBefore"
                        [ngClass]="{ checked :clinicArray[curIndex].slot == 2}">
                        <p style="margin-bottom: 0;"> Slot Two</p>
                      </label>
                    </div>
                  </div>
                </div>
                <div *ngIf="changeable" class="col-md-4">
                  <h4 class="mt-2">{{ clinicArray[curIndex]?.clinicName }}</h4>
                  <div>
                    <p>
                      <i class="fa fa-clock-o"></i>
                      {{ clinicArray[curIndex]?.timming?.startTime }} -
                      <i class="fa fa-clock-o"></i>
                      {{ clinicArray[curIndex]?.timming?.endTime }}
                    </p>

                    <p>
                      <i class="fa fa-map-marker"></i>
                      {{ clinicArray[curIndex]?.address?.line1 }}
                      {{ clinicArray[curIndex]?.address?.city }}
                      {{ clinicArray[curIndex]?.address?.district }}
                      {{ clinicArray[curIndex]?.address?.state }}-
                      {{ clinicArray[curIndex]?.address?.pincode }}
                    </p>

                    <p>
                      <span>Weekly : </span>

                      <span class="badge badge-success" style="margin-right: 5px;"
                        *ngFor="let wd of clinicArray[curIndex]?.weekDays">{{ wd.slice(0, 3) }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <button type="button" class="btn btn-info" *ngIf="doctype === 'RECEPTIONIST'" id="bookappt" style="position: absolute;bottom: 0px;
                  right: 20px;" data-toggle="modal" data-target="#myModalappointmnent">Book Appointment</button>
                  <!-- <button type="button" class="btn btn-success" *ngIf="clinicArray[curIndex]?.bookingType == 'SD' && clinicArray[curIndex]?.tokenBookingTime?.length > 1 " data-toggle="modal" data-target="#changeSlot">change Slot</button> -->
                  <!-- <button type="button" class="btn btn-danger" (click)="doctorType()" >click</button> -->
                  <div class="container">
                    <!-- The Modal -->
                    <div class="modal" id="myModalappointmnent" >
                      <div class="modal-dialog modal-lg">
                        <div class="modal-content" >

                          <!-- Modal Header -->
                          <div class="modal-header">
                            <h4 class="modal-title">Book Appointmemnt</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                          </div>

                          <!-- Modal body -->
                          <div class="modal-body" *ngIf="!clinicData.isMultiselectorType">
                            <form *ngIf="showAppt == false && isLoading == false" class="form-group"
                              [formGroup]="recptform">
                              <p style="text-align:center;font-size:20px"><b>{{clinicArray[curIndex]?.clinicName}}</b>
                              </p>
                              <div class="row">
                                <div class="col-6">
                                  <input type="text" class="form-control" formControlName="name" aria-placeholder="name"
                                    id="name" placeholder="Name" class="form-control"><br>
                                </div>
                                <div class="col-6">
                                  <input type="text" class="form-control" id="GuardiansName"
                                    formControlName="GuardiansName" aria-placeholder="Guardians Name"
                                    placeholder="Guardians Name" class="form-control"><br>
                                </div>
                                <div class="col-6">
                                  <input type="Number" class="form-control" id="phoneNo" formControlName="phoneNo"
                                    aria-placeholder="phoneNo." placeholder="Phone Number" class="form-control"><br>
                                </div>
                                <div class="col-6">
                                  <input type="text" class="form-control" id="address" formControlName="address"
                                    aria-placeholder="address." placeholder="Address" class="form-control"><br>
                                </div>
                                <div class="col-12">
                                  <select class="form-select" style="margin-bottom: 30px;width: 100%; height:36px;"
                                    formControlName="skipDays">
                                    <option value="0" selected>{{moment().format("DD/MM/YYYY")}}</option>
                                    <option *ngFor="let i of skipDaysArray;let index = index " [value]="index+1"
                                      selected>
                                      {{moment().add(index+1,"days").format("DD/MM/YYYY")}}</option>
                                  </select>
                                </div>
                                <div class="col-6">
                                  <select class="form-select" style="margin-bottom: 30px;" formControlName="ageType">
                                    <option value="year" selected>Years</option>
                                    <option value="month">Months</option>
                                    <option value="day">Days</option>
                                  </select>
                                </div>
                                <div class="col-6">
                                  <input style="margin-bottom: 30px;" type="clinic name" class="form-control" id="age"
                                    formControlName="patientAge" aria-placeholder="age" placeholder="Age"
                                    class="form-control">
                                </div>
                                <hr  *ngIf="clinicData && clinicData.type=== 'diagnostic_centre'" />
                                <button *ngIf="clinicData && clinicData.type=== 'diagnostic_centre'" class="btn btn-success" type="button" (click)="advance()">Advance
                                  Option</button>
                                  </div>
                                  </form>
                                  <div *ngIf="showAppt == false && isLoading == false">

                                    <div class="row" *ngIf="showDiv">
                                      <div class="col-6">
                                        <select class="form-select" style="margin-bottom: 30px;" >
                                          <option [value]="member" selected>Select Member</option>
                                          <option [value]="member._id" *ngFor="let member of members" selected>{{member.name}}
                                          </option>
                                        </select>
                                      </div>
                                      <div class="col-6">
                                        <p-multiSelect style="width: 100%;" [(ngModel)]="selectedItems" [options]="items"  (onChange)="onChangeTests($event)"></p-multiSelect>
                                        <!-- <select class="form-select" style="margin-bottom: 30px;" formControlName="ageType" >
                                          <!-- <option value="year" selected>Test 1</option> -->
                                          <!-- <option value="month">Test 2</option> -->
                                          <!-- <option value="day">Test 3</option> -->
                                        <!-- </select> -->
                                      </div>
                                      <div class="col-6">
                                        <input style="margin-bottom: 30px;" type="number" class="form-control" id="age"
                                        [value]="ammount" (input)="onChangeAmmount($event)" aria-placeholder="Amount" placeholder="Amount"
                                          class="form-control">
                                        <!-- <select class="form-select" style="margin-bottom: 30px;" formControlName="ageType">
                                          <option value="year" selected>Years</option>
                                          <option value="month">Months</option>
                                          <option value="day">Days</option> -->
                                        <!-- </select> -->
                                      </div>
                                      <div class="col-6">
                                        <input style="margin-bottom: 30px;" type="clinic name" class="form-control" id="age"
                                           aria-placeholder="Deposit" (input)="onChangeDeposit($event)" [value]="deposit"  placeholder="Deposit"
                                          class="form-control">
                                      </div>
                                    </div>
    
                                  <!-- </div> -->
                                  <button  (click)="Bookreceptionist()" type="buton" [disabled]="(!recptform.valid) && isLoading"
                                    class="btn btn-primary pull-right" id="bookrecpt" >Book
                                    Appointment</button>
                                  </div>
                            <!-- </form> -->
                            <p style="height: 400px;" *ngIf="isLoading">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </p>
                            <div *ngIf="showAppt == true">
                              <img style="height: 50px;width: 50px;display: inline-block;"
                                src="../../../assets/success.gif" />
                              <h3
                                style="color: #00cec9;font-weight: bold;display: inline-block;  margin-bottom: 0;  vertical-align: middle;">
                                Successfully booked</h3>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Name</td>
                                    <td> : {{" "}}</td>
                                    <td>{{bookappointment?.patientName +" "+
                                      "("+bookappointment.patientAge+bookappointment.ageType+"s"+")"}}</td>
                                  </tr>
                                  <tr>
                                    <td>Token</td>
                                    <td> : {{" "}}</td>
                                    <td>{{bookappointment?.appointmentNumber}}</td>
                                  </tr>
                                  <tr>
                                    <td>Phone No.</td>
                                    <td> : {{" "}}</td>
                                    <td>{{bookappointment.patientId.phoneNo}}</td>
                                  </tr>
                                  <tr>
                                    <!-- <th scope="row">3</th> -->
                                    <td>Appointment Date</td>
                                    <td> : {{" "}}</td>
                                    <td><b>{{moment(bookappointment.appointmentDate).format('DD/MM/YYYY')}}</b></td>
                                  </tr>
                                </tbody>
                              </table>
                              <button type="button" class="btn btn-primary"
                                style="padding: 10;display: block !important; margin: 0 auto;"
                                (click)="onNewPatient()">New Patient</button>
                            </div>
                          </div>
                          <div class="modal-body" style="max-height: 80vh;overflow-y: auto;" *ngIf="clinicData.isMultiselectorType && clinicData.isMultiselectorType">
                            <app-token-screen [clinicId]="clinicId" [slots]="clinicData.tokenBookingTime.length"></app-token-screen>
                          </div>
                          <div class="modal-footer">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal" id="changeSlot">
                      <div class="modal-dialog">
                        <div class="modal-content">

                          <div class="modal-header">
                            <h4 class="modal-title">Change Slot</h4>
                            <button type="button" class="close" #changeSlotModelClose
                              data-dismiss="modal">&times;</button>
                          </div>

                          <div class="modal-body">
                            <p *ngIf="!isLoading" style="text-align: center;font-weight: bold;">
                              Switch to Slot {{changeSlotForm?.value?.slot}} ?
                            </p>

                            <p style="height: 400px;" *ngIf="isLoading">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </p>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-primary" (click)="changeSlot()">Confirm</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row pull-right" style="right:19px;position:absolute;top: 55px">
                    <div class="col-md-12" id="status">
                      <button class="btn btn-secondary btn-block text-light" (click)="onStartClinic()"
                        id="clinicstatus1">
                        <span id="clinicstatus">{{ clinicArray[curIndex]?.clinicStatus }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row pull-right" id="app" style="right:33px;top: 8px;
                    position: absolute;">
                    <div class="appClass , col-md-2" style="border-right: 2px solid #fff;padding-top:6px">
                      <i class="fa fa-users" id="p"></i>
                    </div>
                    <div class="appClass , col-md-6" style="padding-top:6px;">
                      <p style="text-align: center;margin-bottom: 7px">
                        APPOINTMENTS:
                      </p>
                    </div>
                    <div class="appClass , col-md-4" style="padding-top:5px;">
                      <h5>
                        {{ appDoc?.appData }} /
                        {{ clinicArray[curIndex]?.patientLimit }}
                      </h5>
                    </div>
                  </div>

                  <div style="top:293px; right: 28px; position: absolute;" *ngIf="doctype != 'RECEPTIONIST'" id="butt">
                    <button data-toggle="modal" data-target="#myModalClinic" class="btn btn-light">
                      <i style="font-size: 20px;color:#0984e3;" class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-light" data-toggle="modal" data-target="#deleteClinicConfirmModal">
                      <i style="font-size: 20px;color:#d63031;" class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content clinic-content col-md-12" style=" margin-top:10px;cursor: pointer;min-height: 120px">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h5 style="color:grey;margin-left:5px;margin-top: 10px">
                      CLINIC PHOTOS
                    </h5>
                  </div>
                  <div class="col-md-8">
                    <button (click)="send()" style="margin-right:20px;" class="btn btn-danger pull-right"
                      *ngIf="clinicArray[curIndex]?.clinicImages?.length !== 0">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <hr />
                <div *ngIf="changeable == false" class="row" style="text-align: center">
                  <div class="col-md-2" *ngFor="
                      let imgt of clinicArray[curIndex]?.hospitalId?.hospitalImages;
                      let i = index">
                    <img class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" (click)="dumyfun(i)"
                      [src]="this.path + imgt.hospitalThumbnail" class="img-thumbnail"
                      style="height:120px;width: 120px;margin-right:5px;margin-bottom: 15px" />
                  </div>
                </div>
                <div *ngIf="changeable == true" class="row" style="text-align: center">
                  <div class="col-md-2" *ngFor="
                      let imgt of clinicArray[curIndex]?.clinicImagesThumbnail;
                      let i = index
                    ">
                    <i (click)="deleteImage(i)" *ngIf="ShowDelete == true || false" class="fa fa-times pull-right"
                      style="background: red;
                      padding: 6px;
                      color: white;" aria-hidden="true"></i>
                    <img class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" (click)="dumyfun(i)"
                      [src]="this.path + imgt" class="img-thumbnail"
                      style="height:120px;width: 120px;margin-right:5px;margin-bottom: 15px" />
                  </div>
                  <div class="col-md-2" id="uploadimg" style="display: none;">
                    <button class="cencleupload" (click)="cencleuploade()"><span>&times;</span></button>
                    <form (ngSubmit)="onSubmit()" class="text-center">
                      <img class="uploadview" [src]="selectedImageUrl || 'http://placehold.it/180'">
                      <button type="submit" class="uploadbutton"><span class="spinner-border spinner-border-sm"
                          role="status" aria-hidden="true" *ngIf="isLoading"></span> <i class="fa fa-upload"
                          style="font-size: 21px;" *ngIf="!isLoading"></i></button>
                    </form>
                  </div>
                  <div class="col-md-2">
                    <form class="text-center">
                      <label id="selectimage" for="file-input">
                        <i class="fa fa-plus" style="font-size: 59px;"></i><br>
                        Add Images</label>
                      <input type="file" id="file-input" (change)="onfilechange($event)"
                        accept="image/x-png,image/gif,image/jpeg" style="display:none;" />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="padding-left: 30px;padding-top: 10px;margin-top: 20px; margin-left: 350px;">
          <div class="row" style="margin-right: 20px">
            <h6 style="margin-right: 20px;color: grey;margin-top:5px">
              DOWNLOAD APP NOW
              <a href="https://play.google.com/store/apps/details?id=com.paspatient" style="text-align: center;">
                <img src="../../../assets/google-play-doqma.svg" style="height:30px;" />
              </a>
            </h6>

          </div>
        </div>
      </main>

      <div class="modal fade" id="deleteClinicConfirmModal">
        <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h6>Delete {{ clinicData?.clinicName }}</h6>
              <button type="button" class="close" data-dismiss="modal" #closebutton #closeClinicDeleteModal>
                &times;
              </button>
            </div>
            <div class="modal-body">
              <h5>Are you sure you want to delete?</h5>

              <p style="color:grey">
                NOTE : All your data related to this clinic will be permanently
                deleted, and you wont be able to see appointments related to
                this <span style="color:blue">{{ clinicData?.clinicName }}</span>..
              </p>
              <div class="container">
                <div class="row">
                  <button (click)="deleteClinic(clinicData._id, clinicData.doctorId)" class="btn btn-danger">
                    Delete
                  </button>
                  <button class="btn btn-light" data-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Clinic Image</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div *ngIf="!changeable" class="modal-body">
              <!-- <form [formGroup]="viewclinicForm">
                <img formControlName="imgForm">
              </form> -->
              <img style="height: 400px;"
                [src]="this.path + clinicArray[curIndex]?.hospitalId?.hospitalImages[viewclinic]?.imagePath"
                class="img-fluid">
              <a *ngIf="clinicArray[curIndex]?.hospitalId?.hospitalImages.length > 1" class="carousel-control-prev"
                (click)="dcCounter()" role="button" data-slide="prev">
                <span class=" imgnavigation carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a *ngIf="clinicArray[curIndex]?.hospitalId?.hospitalImages.length > 1" class="carousel-control-next"
                (click)="incCounter()" role="button" data-slide="next">
                <span class=" imgnavigation carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
            <div *ngIf="changeable" class="modal-body">
              <!-- <form [formGroup]="viewclinicForm">
                <img formControlName="imgForm">
              </form> -->
              <img style="height: 400px;" [src]="this.path + clinicArray[curIndex]?.clinicImages[viewclinic]"
                class="img-fluid">
              <a *ngIf="clinicArray[curIndex]?.clinicImages?.length > 1" class="carousel-control-prev"
                (click)="dcCounter()" role="button" data-slide="prev">
                <span class=" imgnavigation carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a *ngIf="clinicArray[curIndex]?.clinicImages?.length > 1" class="carousel-control-next"
                (click)="incCounter()" role="button" data-slide="next">
                <span class=" imgnavigation carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="myModalClinic">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" #closebutton #closeclinicmodal>
                &times;
              </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <form class="form-horizontal" (ngSubmit)="onSubmitClinicData()" [formGroup]="cddForm">
                <h5 style="text-align: center">Clinic Data Update</h5>

                <div *ngIf="changeable" class="form-group">
                  <label for="clinicName" class="col-sm-3 offset-md-1 control-label">Clinic Name</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="text" id="clinicName" placeholder="clinic name" class="form-control"
                      formControlName="clinicName" />
                  </div>
                </div>

                <div class="form-group">
                  <label for="medicalDegree" class="col-sm-3 offset-md-1 control-label">WorkingDays</label>
                  <span class="badge badge-success" style="margin-right: 5px;"
                    *ngFor="let wd of clinicArray[curIndex]?.weekDays">{{ wd.slice(0, 3) }}</span>

                  <div class="col-sm-9 offset-md-1">
                    <p-multiSelect [options]="clinicDays" [formControl]="cddForm.controls['weekDays']"
                      inputStyleClass="form-control" autoWidth="true" display="chip"
                      [style]="{ width: '100%' }"></p-multiSelect>
                  </div>
                </div>
                <div class="form-group">
                  <label for="patientLimit" class="col-sm-3 offset-md-1 control-label">PatientLimit</label>
                  <div class="col-sm-9 offset-md-1">
                    <input id="patientLimit" placeholder="patientLimit" class="form-control"
                      formControlName="patientLimit" autofocus />
                  </div>
                </div>
                <div class="form-group">
                  <label for="patientLimit" class="col-sm-3 offset-md-1 control-label">Slots</label>
                  <div class="col-sm-9 offset-md-1">
                    <select placeholder="Slots" id="slots" class="form-control" formControlName="slots" autofocus>
                      <option>1</option>
                      <option>2</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="startTime" class="col-sm-3 offset-md-1 control-label">Opening Time</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="time" name="starttime" class="form-control" formControlName="startTime" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="endTime" class="col-sm-3 offset-md-1 control-label">Closing Time
                  </label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="time" name="endtime" class="form-control" formControlName="endTime" />
                  </div>
                </div>
                <div *ngIf="changeable" class="form-group">
                  <label for="line1" class="col-sm-3 offset-md-1 control-label">Address*</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="text" id="line1" placeholder="Address" class="form-control" formControlName="line1" />
                  </div>
                </div>

                <div *ngIf="changeable" class="form-group">
                  <label for="city" class="col-sm-3 offset-md-1 control-label">District*</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="text" id="city" placeholder="district" class="form-control"
                      formControlName="district" />
                  </div>
                </div>
                <div *ngIf="changeable" class="form-group">
                  <label for="city" class="col-sm-3 offset-md-1 control-label">City</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="text" id="city" placeholder="City" class="form-control" formControlName="city" />
                  </div>
                </div>
                <div *ngIf="changeable" class="form-group">
                  <label for="state" class="col-sm-3 offset-md-1 control-label">State*</label>
                  <div class="col-sm-9 offset-md-1">
                    <select class="form-control" id="state" formControlName="state">
                      <option value="AP">Andhra Pradesh</option>
                      <option value="AR">Arunachal Pradesh</option>
                      <option value="AS">Assam</option>
                      <option value="BR">Bihar</option>
                      <option value="CG">Chhattisgarh</option>
                      <option value="GA">Goa</option>
                      <option value="GJ">Gujrat</option>
                      <option value="HR">Haryana</option>
                      <option value="HP">Himachal Pradesh</option>
                      <option value="JH">Jharkand</option>
                      <option value="KA">Karnataka</option>
                      <option value="KL">Kerla</option>
                      <option value="MP">Madhya Pradesh</option>
                      <option value="MH">Maharashtra</option>
                      <option value="MN">Manipur</option>
                      <option value="ML">Meghalaya</option>
                      <option value="MZ">Mizoram</option>
                      <option value="NL">Nagaland</option>
                      <option value="OD">Odisha</option>
                      <option value="PB">Punjab</option>
                      <option value="RJ">Rajasthan</option>
                      <option value="SK">Sikkim</option>
                      <option value="TN">Tamil Nadu</option>
                      <option value="TS">Telangana</option>
                      <option value="TR">Tripura</option>
                      <option value="UP">Uttar Pradesh</option>
                      <option value="UK">Uttarakhand</option>
                      <option value="WB">West Bengal</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="changeable" class="form-group">
                  <label for="pincode" class="col-sm-3 offset-md-1 control-label">PinCode*</label>
                  <div class="col-sm-9 offset-md-1">
                    <input type="text" id="pincode" placeholder="Pincode" class="form-control"
                      formControlName="pincode" />
                  </div>
                </div>
                <div class="col-sm-9 offset-md-1">
                  <!-- [disabled]="isLoading" -->
                  <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    Update ClinicData
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>